export default __webpack_public_path__ + "5cd869a1969281860237502b80bf5108.glb";